import Chip from "@/components/Chip";
import SimpleTable from "@/components/SimpleTable";
import { Button } from "@/components/ui/button";
import { AnswerSubCategory } from "@/schema/console/checking-assessments/AnswerSubCategory";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface CategoryTableProps {
  data: AnswerSubCategory[];
}

function SubCategoryTable({ data }: CategoryTableProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <SimpleTable
      data={data}
      columns={[
        {
          key: "name",
          label: t("assessment-items"),
          render: ({ content, question_count }) => (
            <div className="flex-col">
              <div className="font-medium">{content}</div>
              <div>
                {question_count} {t("questions")}
              </div>
            </div>
          ),
        },
        {
          key: "status",
          label: t("status"),
          width: "200px",
          render: ({ is_checked }) => {
            return is_checked ? (
              <Chip label={t("checked")} />
            ) : (
              <Chip variant="info" label={t("not-checked")} />
            );
          },
        },
        {
          key: "action",
          label: t("action"),
          width: "150px",
          render: ({ id, is_checked }) => (
            <Button
              variant="outline"
              onClick={() => navigate(`sub-categories/${id}`)}
            >
              {is_checked ? t("view") : t("check")}
            </Button>
          ),
        },
      ]}
    />
  );
}

export default SubCategoryTable;
